module.exports = __webpack_public_path__ + "static/img/check-nofill.2efa4da3.svg";